import { css } from '@emotion/css';

import { Colors, FontWeight, Spacing } from '../../styles/constants';

export const statusClassName = css({
  display: 'flex',
});

export const innerClassName = css({
  alignItems: 'center',
  background: 'rgba(10, 191, 83, 0.1)',
  borderRadius: 100,
  display: 'flex',
  justifyContent: 'center',
  padding: '4px 16px',
});

export const iconClassName = css({
  color: Colors.Green,
  height: 8,
  width: 8,
  marginRight: Spacing.XS,
});

export const labelClassName = css({
  color: Colors.DarkGreen,
  fontSize: 12,
  fontWeight: FontWeight.BOLD,
});
